import React from 'react';
import Icon, { IconProps } from '../Icon';

const SquarePlusIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 62 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="60.2"
          height="41"
          rx="4.5"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeDasharray="3 3"
        />
        <path
          d="M20.9333 21.2942H29.4275V29.7884C29.4275 30.1934 29.7555 30.5218 30.1608 30.5218C30.5662 30.5218 30.8942 30.1934 30.8942 29.7884V21.2942H39.3884C39.7937 21.2942 40.1217 20.9659 40.1217 20.5609C40.1217 20.1559 39.7937 19.8275 39.3884 19.8275H30.8942V11.3333C30.8942 10.9284 30.5662 10.6 30.1608 10.6C29.7555 10.6 29.4275 10.9284 29.4275 11.3333V19.8275H20.9333C20.5279 19.8275 20.2 20.1559 20.2 20.5609C20.2 20.9659 20.5279 21.2942 20.9333 21.2942Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};
export default SquarePlusIcon;
